/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_On_CompatibilityInputs */

const en_wc_on_compatibility = /** @type {(inputs: Wc_On_CompatibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open in compatibility mode`)
};

/**
* | output |
* | --- |
* | "Open in compatibility mode" |
*
* @param {Wc_On_CompatibilityInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_on_compatibility = /** @type {((inputs?: Wc_On_CompatibilityInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_On_CompatibilityInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_on_compatibility(inputs)
});
export { wc_on_compatibility as "wc.on.compatibility" }